import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import Pagination from '@mui/material/Pagination';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 1000,
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  overflowY: 'auto',
};

const getUrlFromImageAsset = (image) => `/preview/asset/${image.id}?instanceName=sandbox`;

const Gallery = ({ images = [], formContext }) => {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const imagesPerPage = 9;
  const totalPages = Math.ceil(images.length / imagesPerPage);

  const selectedAssetId = formContext?.watch('selectedAssetId');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handlePageChange = (event, value) => setPage(value);

  const handleImageSelect = (image) => {
    formContext?.setValue('selectedAssetId', image.id, { shouldDirty: true });
    handleClose();
  };

  // Get current page's images
  const currentImages = images.slice((page - 1) * imagesPerPage, page * imagesPerPage);

  return (
    <div>
      <Button
        onClick={handleOpen}
        variant="contained"
        color="primary"
        style={{ marginBottom: '10px', width: '200px' }}
      >
        Browse Gallery
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="gallery-modal"
        aria-describedby="gallery-modal-description"
      >
        <Box sx={modalStyle}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: 'grey.500',
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <ImageList sx={{ width: '100%', height: 'auto' }} cols={3} gap={2}>
            {currentImages.map((image) => (
              <ImageListItem
                key={image.id}
                sx={{
                  cursor: 'pointer',
                  '&:hover': { opacity: 0.8 },
                  border: selectedAssetId === image.id ? '2px solid #1976d2' : 'none',
                  borderRadius: '4px',
                }}
                onClick={() => handleImageSelect(image)}
              >
                <img
                  src={getUrlFromImageAsset(image)}
                  alt={image.id}
                  loading="lazy"
                  style={{ width: '200px', height: '200px', objectFit: 'cover' }}
                />
                {selectedAssetId === image.id && (
                  <ImageListItemBar
                    sx={{ background: 'rgba(25, 118, 210, 0.7)' }}
                    position="top"
                    actionIcon={
                      <IconButton sx={{ color: 'white' }}>
                        <CheckCircleIcon />
                      </IconButton>
                    }
                  />
                )}
              </ImageListItem>
            ))}
          </ImageList>
          {totalPages > 1 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
              />
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default Gallery;
